import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { history } from 'containers/App';
import LocalisedMessage from 'components/Common/LocalisedMessage';

import ErrorPage from 'components/Errors/ErrorPage';

const UnauthorisedError = ({ titleTextId }) => {
  const actionUrl = useSelector(state => state?.app?.messages?.unauthorisedActionUrl);

  const onClick = () => {
    if (actionUrl) {
      window.location = actionUrl;
      return;
    }
    history.push('/'); window.location.reload();
  };

  return (
    <ErrorPage title="Access Denied" titleTextId={ titleTextId } type="server" showButton onButtonClick={ () => onClick() }>
      <LocalisedMessage
        id="unauthorized.content"
        values={ {
          // eslint-disable-next-line react/no-unstable-nested-components
          error401: chunks => <p className="cp-primary"><b>{ chunks }</b></p>
        } }
      />
    </ErrorPage>
  );
};

UnauthorisedError.propTypes = {
  titleTextId: PropTypes.string
};

UnauthorisedError.defaultProps = {
  titleTextId: 'unauthorized.title'
};

export default UnauthorisedError;
